import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Select } from 'antd';
import { AddStudentFormWrapper, Label } from './user.style';
import { useSave } from '../hooks/useSave';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useGrade } from '../../routine/hooks/useGrade';
import { GradeModel } from 'data/grade/grade.model';
import AssignParent from './assignParent';
import AssignParentUI from './AssignParentUI';
import CreateStudentAndAssignNewParent from './components/CreateStudentAndAssignNewParent';
import CreateStudentAndAssignParent from './components/CreateStudentAndAssignParent';

export const AddStudentForm = (props: any) => {
  const { onVisibleChange, onSetReloadAfterDrawer } = props;
  const [form] = Form.useForm();
  const { onStudentSave } = useSave();
  const { fetchGrade } = useGrade();
  const [alreadyAdded, setAlreadyAdded] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [showParentUI, setShowParentUI] = useState(false);

  const [gradeData, setGradeData] = React.useState<GradeModel>({
    id: '',
    startTime: '',
    endTime: '',
    sections: [],
  });
  const grade = useSelector((state: RootState) => state.grade);

  const handleCheckBoxClick = (type: 'addNew' | 'alreadyAdded'): void => {
    if (showParentUI || addNew || alreadyAdded) return;
    if (
      form.getFieldsValue().username &&
      form.getFieldsValue().full_name &&
      form.getFieldsValue().grade &&
      form.getFieldsValue().section &&
      form.getFieldsValue().password &&
      form.getFieldsValue().address
    ) {
      setShowParentUI(true);
      if (type === 'addNew') {
        if (!addNew) setAddNew(true);
      }
      if (type === 'alreadyAdded') {
        if (!alreadyAdded) setAlreadyAdded(true);
      }
    }
  };

  const onChange = () => {
    if (!showParentUI) return;
    setAlreadyAdded((prev) => !prev);
    if (addNew) {
      setAddNew((prev) => !prev);
    }
  };
  const onChangeAddNew = () => {
    if (!showParentUI) return;
    setAddNew((prev) => !prev);
    if (alreadyAdded) {
      setAlreadyAdded((prev) => !prev);
    }
  };

  React.useEffect(() => {
    fetchGrade();
  }, []);

  return (
    <AddStudentFormWrapper>
      <Form form={form} name="nest-messages" layout="vertical" size="large">
        <Form.Item label="Full Name" name={'full_name'}>
          <Input />
        </Form.Item>
        <Form.Item label="Username" name={'username'}>
          <Input />
        </Form.Item>
        <div className="gradeRollSection">
          <Form.Item label="Grade" name="grade" style={{ marginRight: 20 }}>
            <Select
              style={{ width: 250 }}
              defaultValue="Select Grade"
              className="grade-select-field"
              onSelect={(value) => {
                grade.data.map((item) => {
                  if (item.id === value) {
                    setGradeData(item);
                  }
                });
              }}
            >
              {grade.data.map((item) => (
                <Select.Option key={`atten-class${item.id}`} value={item.id}>
                  {item.id}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Section" name="section">
            <Select
              defaultValue="Select Section"
              className="grade-select-field"
              style={{ width: 250 }}
            >
              {gradeData.sections.map((section) => (
                <Select.Option key={`atten-class${section.id}`} value={section.id}>
                  {section.id}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <Form.Item
          label="Email (optional)"
          name={'email'}
          required={false}
          rules={[
            {
              type: 'email',
              message: 'The input is not valid E-mail!',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Phone Number (optional)" name={'phone_number'} required={false}>
          <Input />
        </Form.Item>
        <Form.Item label="Password" name="password">
          <Input.Password />
        </Form.Item>
        <Form.Item label="Address" name={'address'}>
          <Input />
        </Form.Item>
        <h1>Assign Parent to this student</h1>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            marginTop: '1rem',
          }}
        >
          <Checkbox
            onClick={() => handleCheckBoxClick('addNew')}
            onChange={onChangeAddNew}
            checked={addNew}
            style={{
              border: '1px solid #763535',
              padding: '10px 15px',
              fontSize: '18px',
              borderRadius: '5px',
            }}
          >
            Add New
          </Checkbox>
          <Checkbox
            onClick={() => handleCheckBoxClick('alreadyAdded')}
            onChange={onChange}
            checked={alreadyAdded}
            style={{
              border: '1px solid #763535',
              fontSize: '18px',
              borderRadius: '5px',
              padding: '10px 15px',
            }}
          >
            Already Added
          </Checkbox>
        </div>

        {addNew && showParentUI && (
          <>
            <CreateStudentAndAssignNewParent
              onVisibleChange={onVisibleChange}
              onSetReloadAfterDrawer={onSetReloadAfterDrawer}
              studentDetails={{
                username: form.getFieldsValue().username,
                full_name: form.getFieldsValue().full_name,
                grade: form.getFieldsValue().grade,
                section: form.getFieldsValue().section,
                email: form.getFieldsValue().email,
                phone_number: form.getFieldsValue().phone_number,
                password: form.getFieldsValue().password,
                address: form.getFieldsValue().address,
              }}
            />
          </>
        )}
        {alreadyAdded && showParentUI && (
          <>
            <CreateStudentAndAssignParent
              studentDetails={{
                username: form.getFieldsValue().username,
                full_name: form.getFieldsValue().full_name,
                grade: form.getFieldsValue().grade,
                section: form.getFieldsValue().section,
                email: form.getFieldsValue().email,
                phone_number: form.getFieldsValue().phone_number,
                password: form.getFieldsValue().password,
                address: form.getFieldsValue().address,
              }}
            />
          </>
        )}
        {/* <Form.Item>
          <Button
            htmlType="submit"
            onClick={() => {
              onStudentSave(
                { ...form.getFieldsValue() },
                form,
                onVisibleChange,
                onSetReloadAfterDrawer,
              );
            }}
          >
            SAVE
          </Button>
        </Form.Item> */}
      </Form>
    </AddStudentFormWrapper>
  );
};

export default AddStudentForm;
